import React, { useCallback, useMemo, useState } from 'react'

import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import '../../index.scss'
import LtsLookup from './lts-lookup'
import { InputText } from 'primereact/inputtext'

// Constantes de classes CSS das colunas
const COLUMN_CLASSES = {
  oid: {
    body: 'column-codigo-body-width',
    filterHeader: 'column-codigo-filter-header-width',
    header: 'column-codigo-header-width',
  },
  nome: {
    body: 'column-descricao-body-width',
    filterHeader: 'column-descricao-filter-header-width',
    header: 'column-descricao-header-width',
  },
}

// Configuração das colunas
const COLUMNS_CONFIG = [
  {
    field: 'oid',
    header: 'Código',
    columnKey: 'oid',
    sortable: false,
    filter: true,
    columnSortField: 'oid',
    visible: true,
  },
  {
    field: 'nome',
    header: 'Nome',
    columnKey: 'nome',
    columnSortField: 'nome',
    sortable: true,
    filter: true,
    visible: true,
  },
]

export default function LtsLookupConfiguracaoPixAutomatico(props) {
  const { label, value, name, field, history, onChange, oidRecord, editDisabled, editHidden } = props

  const [filters, setFilters] = useState([])

  // Configuração de colunas memoizada para evitar re-renders desnecessários
  const columns = useMemo(() => COLUMNS_CONFIG, [])

  // Função de chamada de API memoizada
  const loadDataFn = useCallback((params) => {
    return apiService.post(`/lottustech/configuracoesPixAutomatico/all`, params)
  }, [])

  // Manipula tecla pressionada para definir filtro inicial baseado no valor atual
  const onKeyPress = useCallback(() => {
    // Substituído _.get por optional chaining
    if (value?.nome) {
      const newFilters = [new Filtro('nome', value.nome, 'CONTEM')]
      setFilters(newFilters)
    }
  }, [value])

  // Gera caminho de edição baseado no OID do registro
  const pathOnEditFn = useCallback(() => {
    // Substituído _.get por optional chaining e simplificado condicional
    return oidRecord
      ? `${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}/${oidRecord}`
      : `${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}/novo`
  }, [oidRecord])

  // Manipula mudanças no filtro de entrada
  const onInputFilter = useCallback(
    (e) => {
      const inputValue = e.value
      if (typeof inputValue === 'string') {
        onChange({
          oid: '',
          nome: inputValue,
        })
      } else {
        onChange(inputValue)
      }
    },
    [onChange]
  )

  // Template para exibição do autocomplete
  const autoCompleteTemplate = useCallback((data) => {
    return `${data.oid} - ${data.nome}`
  }, [])

  // Manipula mudanças nos filtros da tabela
  const handleTableFilterChange = useCallback(
    (column, e) => {
      const campo = column.field

      // Remove filtro existente para este campo
      const newFilters = filters.filter((f) => f.campo !== campo)

      const valor = e?.target?.value
      if (valor) {
        const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
        newFilters.push({ campo, valor, tipoFiltro })
      }

      setFilters(newFilters)
    },
    [filters]
  )

  // Renderiza elemento de filtro de entrada para uma coluna
  const renderColumnFilter = useCallback(
    (column) => {
      return (
        <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => handleTableFilterChange(column, e)} />
      )
    },
    [handleTableFilterChange]
  )

  // Renderiza colunas com estilização e filtros apropriados
  const renderColumns = useCallback(() => {
    return columns.map((col) => {
      // Remove props que não devem ser espalhadas para elementos DOM
      const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

      const classes = COLUMN_CLASSES[col.field]
      if (!classes) return null

      return (
        <Column
          {...columnProps}
          key={col.field}
          bodyClassName={classes.body}
          filterHeaderClassName={classes.filterHeader}
          headerClassName={classes.header}
          filterElement={renderColumnFilter(col)}
        />
      )
    })
  }, [columns, renderColumnFilter])

  // Resolve e aumenta filtros com critérios adicionais
  const resolveFilters = useCallback((filters) => {
    return filters
  }, [])

  return (
    <LtsLookup
      label={label}
      value={value}
      name={name}
      field={field}
      history={history}
      autoCompleteTemplate={autoCompleteTemplate}
      onKeyPress={onKeyPress}
      onInputFilter={onInputFilter}
      pathOnEditFn={pathOnEditFn}
      header={label}
      columns={columns}
      onResolvingColumn={renderColumns}
      loadDataFn={loadDataFn}
      resolveFilters={resolveFilters}
      onChange={onChange}
      filters={filters}
      setFilters={setFilters}
      editDisabled={editDisabled}
      editHidden={editHidden}
    />
  )
}
